<template>
  <div class="dish">
    <h3>
      <span v-if="code">{{ code + "." }}</span> {{ name }}
    </h3>
    <p v-if="description.nl">{{ description.nl }}</p>
    <p v-if="description.en">{{ description.en }}</p>
    <h4>&euro; {{ price }} </h4>
  </div>
</template>

<script>
export default {
  props: ['code', 'name', 'description', 'price']
}
</script>

<style lang="scss" scoped>
.dish {
  float: left;
  width: 50%;
  height: 13rem;
  padding: 1.5rem;
  box-sizing: border-box;

  h3 {
    color: #e74c3c;
    font-size: 1.5em;
    font-family: 'Macondo Swash Caps', cursive;
  }

  p {
    font-family: 'Aleo-light'
  }
}

@media screen and (max-width: 600px) {
  .dish {
    padding: 0.2rem;
    height: 13rem;

    p {
      font-size: 0.8em;
      margin-bottom: 8px;;
      margin-top: 0;
    }

    h3 {
      font-size: 1.2em;
    }

    h4 {
      font-size: 1.1em;
      margin-top: 0;
    }
  }
}
</style>
